<template>
  <div>
    <!-- 会員基本情報 -->
    <el-row type="flex" align="middle" :gutter="20">
      <el-col :span="4">
        <p>{{ $locale("membership.memberList.dialog.basic") }}</p>
      </el-col>
      <el-col :span="20" class="ta-r">
          <el-button :disabled="getDetailDisable" @click="editUserInfo" class="egl-btn-yellow">会員基本情報編集</el-button>
          <el-button :disabled="getDetailDisable" @click="deleteMember_fn" class="egl-btn-yellow" style="background-color: rgba(225, 76, 76, 1);">{{ $locale("membership.memberList.dialog.deleteAccount") }}</el-button>
        </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="6">
        <!-- 会員ID -->
        <el-form-item :label="$locale('membership.coupon.memberID')">{{ propForm.memberNum }}</el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- ステータス -->
        <el-form-item :label="$locale('global.state')">{{ formatStatus(propForm.memberStatus) }}</el-form-item>
      </el-col>
      <el-col :span="10">
        <!-- 加入日付 -->
        <el-form-item :label="$locale('membership.memberList.dialog.enrollmentDate')">{{
        !propForm.createTime || isNaN(propForm.createTime) ? '' : $moment(propForm.createTime).format("YYYY.MM.DD")
        }}</el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="6">
        <!-- 好きなジャンル -->
        <el-form-item :label="$locale('membership.memberList.dialog.favoriteGenre')">
          <el-row :gutter="5">
            <template v-if="(propForm.member || {}).favoriteGenres && (propForm.member || {}).favoriteGenres.length > 0">
              <el-col v-for="(str, idx) in (propForm.member || {}).favoriteGenres" :key="idx" :span="8">
                <span class="tag" :title="str">{{ str }}</span>
              </el-col>
            </template>
            <template v-else>入力なし</template>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- 鑑賞回数 -->
        <el-form-item :label="$locale('membership.memberList.viewNumbers')">
          <el-row :gutter="5">
              <el-col>{{ (propForm.member || {}).totalViews }}</el-col>
          </el-row>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- 累計消費金額 -->
        <el-form-item :label="$locale('membership.memberList.dialog.amount')">{{ (propForm.member || {}).totalCost !== void 0 ? "¥" + priceFormatter((propForm.member || {}).totalCost) : "" }}</el-form-item>
      </el-col>
      <!-- 所有ポイント -->
      <el-col :span="6">
        <el-form-item :label="$locale('membership.memberList.totalPoint')">{{ (propForm.member || {}).point }}</el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- 会員の累計ポイント -->
        <el-form-item :label="$locale('membership.memberList.memberPoint')">{{ (propForm.member || {}).totalPoint }}</el-form-item>
      </el-col>
      <el-col :span="6">
        <!-- お気に入り映画館 -->
        <!-- <el-form-item :label="$locale('membership.memberList.dialog.favTheater')">{{ (propForm.member || {}).favoriteCinema || '入力なし' }}</el-form-item> -->
        <el-form-item :label="$locale('membership.memberList.dialog.favTheater')">{{ getCinemaNames }}</el-form-item>
      </el-col>
    </el-row>
    <el-dialog 
      :visible.sync="isShow"
      :show-close="false"
      class="egl-dialog-elm channel-dialog"
      title="会員基本情報編集"
      :close-on-click-modal="false"
      :append-to-body="true">
      <el-form
        ref="basicInfoForm"
        :model="basicInfo"
        label-position="top"
        :rules="infoRules"
       >
       <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('membership.coupon.memberID')">
            <el-input v-model="propForm.memberNum" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('global.state')">
            <el-select v-model="basicInfo.memberStatus">
              <el-option v-for="(item, idx) in getMemberStatus()"
                :disabled="item.value !== 'general' && item.value !== 'disabled'"
                :label="item.text"
                :value="item.value"
                :key="item.value"
              >
              <el-tooltip :content="item.tips" placement="top" v-if="item.value === 'frequent' || item.value === 'sleeping'">
                <span>{{ item.text }}</span>
              </el-tooltip>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.dialog.enrollmentDate')">
            <el-date-picker v-model="basicInfo.createTime" :clearable="false" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.dialog.favoriteGenre')">
            <el-row :gutter="5">
              <template v-if="(propForm.member || {}).favoriteGenres && (propForm.member || {}).favoriteGenres.length > 0">
                <el-col v-for="(str, idx) in (propForm.member || {}).favoriteGenres" :key="idx" :span="8">
                  <span class="tag" :title="str">{{ str }}</span>
                </el-col>
              </template>
              <template v-else>入力なし</template>
            </el-row>
          </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.viewNumbers')" prop="totalViews">
            <el-input v-model="basicInfo.totalViews" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.dialog.amount')" prop="totalCost">
            <el-input v-model="basicInfo.totalCost" />
          </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.totalPoint')" prop="point">
            <el-input v-model="basicInfo.point" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.memberPoint')" prop="totalPoint">
            <el-input v-model="basicInfo.totalPoint" />
          </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$locale('membership.memberList.dialog.favTheater')">{{ getCinemaNames }}</el-form-item>
        </el-col>
       </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="center" style="margin-top: 37px;">
        <el-col :span="16" style="display: flex; justify-content: space-around;">
          <template>
            <el-button class="egl-btn-white" style="width: 250px;" @click="isShow = false">
              {{ $locale("global.cancel") }}
            </el-button>
            <el-button class="egl-btn-yellow" style="width: 250px;background-color: rgba(249, 218, 73, 0.5);" @click="save_fn">
              {{ $locale("global.save") }}
            </el-button>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { getMemberStatus, priceFormatter, displayConfirm } from "@/assets/js/membership"
import { updateMemberStatusService, deleteMemberService, getMemberDetailService, updateMemberInfoService } from "@/helpers/service/api/membership"
import countDownAlert from "@/utils/countDownAlert";
export default {
  inject: ["getList_fn", "isDeatilDisable", "getListDetail_fn", "cinemaList"],
  data() {
    return {
      priceFormatter,
      isShow: false,
      basicInfo: {
        memberStatus: this.propForm.memberStatus,
        createTime: this.propForm.createTime,
        totalViews: (this.propForm.member || {}).totalViews,
        totalCost: (this.propForm.member || {}).totalCost,
        point: (this.propForm.member || {}).point,
        totalPoint: (this.propForm.member || {}).totalPoint,
      },
      getMemberStatus,
      infoRules: {
        totalViews: [{
          validator: this.validNumber,
          trigger: "blur",
        }],
        totalCost: [{
          validator: this.validNumber,
          trigger: "blur",
        }],
        point: [{
          validator: this.validNumber,
          trigger: "blur",
        }],
        totalPoint: [{
          validator: this.validNumber,
          trigger: "blur",
        }],
      }
    }
  },
  computed: {
    getDetailDisable() {
      return this.isDeatilDisable()
    },
    injectCinemaList() {
      return this.cinemaList();
    },
    getCinemaNames() {
      let names = [];
      // 添加空值检查
      if (this.propForm.member && this.propForm.member.favoriteCinemaId && Array.isArray(this.propForm.member.favoriteCinemaId)) {
        this.propForm.member.favoriteCinemaId.forEach(id => {
          const cinema = this.injectCinemaList.find(item => item.id === id)
          if (cinema) {
            names.push(cinema.name)
          }
        });
      }
      if (names.length > 0) {
        return names.join(", ");
      } else {
        return "入力なし";
      }
    }
  },
  props: {
    propForm: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatStatus(status) {
      console.log(getMemberStatus().find(item => item.value === status))
      return (getMemberStatus().find(item => item.value === status) || {}).text
    },
    editUserInfo() {
      // const elContent = `<p style="margin-bottom:20px;text-align:left;">利用停止すると、お客様がすぐ会員優待を利用できなくなります。</p>
      // <p style="margin-bottom:20px;text-align:left;">再度にご利用するには、CMSから利用開始の操作をしてください。</p>
      // <p>よろしいでしょうか。</p>`
      // this.updateStatus_fn(elContent, this.$locale("membership.memberList.dialog.stopUsing"))
      console.log('open Dialog');
      this.isShow = true;
      this.basicInfo.createTime = this.propForm.createTime;
      this.basicInfo.memberStatus = this.propForm.memberStatus;
      this.basicInfo.point = this.propForm.member.point;
      this.basicInfo.totalPoint = this.propForm.member.totalPoint;
      this.basicInfo.totalViews = this.propForm.member.totalViews;
      this.basicInfo.totalCost = this.propForm.member.totalCost;
    },
    save_fn() {
      console.log('call api!!!');
      console.log(this.$refs.basicInfoForm);
      this.$refs.basicInfoForm.validate(isValid => {
        console.log(isValid);
        if (isValid) {
          updateMemberInfoService({
            userId: this.propForm.id,
            memberInfo: this.basicInfo,
          }).then(res => {
            if (res.success) {
              countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: () => {
                this.getListDetail_fn(this.propForm.id);
                this.isShow = false;
              }});
            }
          })
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      })
    },
    validNumber(_, value, callback) {
      if (value === '' || !/^[0-9]\d*$/.test(value)) {
        callback(new Error(this.$locale("form.mustFillInNum")));
      } else {
        callback()
      }
    },
    reopenStatus_fn() {
      const elContent = `<p style="margin-bottom:20px;">こちらのお客様を利用再開しても よろ</p>
      <p>しいでしょうか？</p>`
      this.updateStatus_fn(elContent, this.$locale("membership.memberList.dialog.reopen"))
    },
    updateStatus_fn(elContent, btnText) {
      displayConfirm(elContent, btnText, () => {
        updateMemberStatusService({
          id: this.propForm.id
        }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: () => {
              getMemberDetailService({
                userId: this.propForm.id
              }).then(res => {
                this.propForm.memberStatus = res.data.memberStatus
                this.getList_fn()
              })
            } })
          }
        })
      })
    },
    deleteMember_fn() {
      // 退会 (MemberStatus.delete) wording per human.answer-1
      const elContent = `<p style="margin-bottom:20px;text-align:left;">退会すると、お客様がすぐ会員優待を利用できなくなります。</p>
      <p style="margin-bottom:20px;text-align:left;">また、アカウント情報や利用履歴など、個人情報が永久に削除されます。</p>
      <p style="color: rgba(255, 80, 80);margin-bottom:20px;text-align:left;">この操作は、復元はできません。</p>
      <p>よろしいでしょうか。</p>`
      displayConfirm(elContent, this.$locale("membership.memberList.dialog.deleteAccount"), () => {
        deleteMemberService({
          id: this.propForm.id
        }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: () => {
              getMemberDetailService({
                userId: this.propForm.id
              }).then(res => {
                this.propForm.memberStatus = res.data.memberStatus
                this.getList_fn()
              })
            } })
          }
        })
      })
    }
  }
}
</script>
<style lang="less">
  .tag {
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    max-width: 100%;
    height: 25px;
    line-height: 25px;
    border-radius: 5px;
    background-color: #D8D8D8;
    padding: 0 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
</style>